import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { NextSeo } from 'next-seo';

import { Button } from '../components/button/button-component';
import NextImage from '../components/image/image';
import { Typography } from '../components/typography/typography-component';
import Footer from '../components/valuebell/footer';
import Navbar from '../components/valuebell/navbar';

const Valuebell = () => {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_URL}/valuebell`;

  const SEO = {
    title: 'ValueBell',
    description:
      'No more need to rely on Email to reach your own users. Engage them right in your SaaS App with ValueBell.',
    openGraph: {
      type: 'page',
      url: pageUrl,
      site_name: 'ValueBell',
      title: 'ValueBell',
      description:
        'No more need to rely on Email to reach your own users. Engage them right in your SaaS App with ValueBell.',
    },
    canonicalUrl: pageUrl,
  };

  return (
    <>
      <NextSeo {...SEO} />
      <Navbar />

      <div className="bg-white px-4">
        <div className="mx-auto my-12 px-2 md:container sm:w-full md:px-0">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            <div className="mt-0 lg:mt-32">
              <Typography variant="h1" className="font-GTWalsheimPro">
                The in-app notification system for SaaS
              </Typography>
              <Typography variant="paragraph" className="mt-4 font-avenir">
                No more need to rely on Email to reach your own users. Engage
                them right in your SaaS App with ValueBell.
              </Typography>

              <div className="mt-8 flex w-full overflow-hidden rounded-xl md:w-10/12">
                <div className="flex w-full w-full items-center bg-[#F5F8FA] p-4">
                  <EnvelopeIcon className="mr-4 h-5 w-5" />
                  <input
                    placeholder="Add your email address"
                    className="w-full bg-[#F5F8FA] font-avenir focus:outline-none"
                    name="email"
                  />
                </div>
                <button className="w-[300px] bg-orange px-6 py-4 font-GTWalsheimPro text-sm text-white">
                  Get Started for free
                </button>
              </div>
            </div>

            <div className="relative hidden h-full w-full bg-gradient-to-b from-[#EDEFF5] to-[#ffffff] p-12 lg:block">
              <NextImage
                className="w-full"
                src="/valuebell-graphic.svg"
                alt="Graphic"
                unoptimized
                width={600}
                height={600}
              />
              <div className="absolute -left-[80px] bottom-0">
                <NextImage
                  src="/vector.svg"
                  alt="Graphic"
                  unoptimized
                  width={240}
                  height={240}
                />
              </div>
            </div>
          </div>

          <div className="mt-8 flex justify-center rounded-xl bg-[#064649] px-4 py-16 text-white">
            <div className="flex w-full flex-col items-center text-center md:w-1/2 lg:w-1/3">
              <Typography variant="h1" className="font-GTWalsheimPro">
                Launch Asap
              </Typography>
              <Typography variant="paragraph" className="mt-4 font-avenir">
                Let’s prove to you that building a notification system should
                not take months
              </Typography>
              <a
                target="_blank"
                href="https://tally.so/r/wArQyo"
                rel="noreferrer"
              >
                <Button
                  size="lg"
                  variant="filled"
                  color="orange"
                  className="mt-8 font-GTWalsheimPro hover:bg-orange"
                >
                  Get Early Access
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Valuebell;
